import React from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Row,
} from 'reactstrap';

import Grid from '../../../components/cms/grid';
import AddNewButton from '../../../components/cms/grid/addNewButton';
import ModelService from '../../../services/post.service';

const initCriteria = {
  id: '',
  title: '',
  content: '',
  status: '',
};

const Posts = ({ t, getColumns, pageList }) => (
  <div className="">
    <Row>
      <Col xl={12}>
        <Card>
          <CardHeader>
            <strong><i className="fa fa-edit" /> {t('Posts')}</strong>
          </CardHeader>
          <CardBody>
            <div className="pull-right mb-1">
              <AddNewButton
                to={ModelService.getCreateUrl()}
                permissionToCreate={ModelService.getCreatePermissions()}
              />
            </div>
            <Grid
              id="posts"
              service={ModelService}
              columns={getColumns(pageList, t)}
              initCriteria={initCriteria}
            />
          </CardBody>
        </Card>
      </Col>
    </Row>
  </div>
);

Posts.propTypes = {
  t: PropTypes.func.isRequired,
  getColumns: PropTypes.func.isRequired,
  pageList: PropTypes.array.isRequired,
};

export default Posts;



// WEBPACK FOOTER //
// ./src/views/blog/posts/Posts.jsx